// extracted by mini-css-extract-plugin
var _1 = "NewPostSelectOption-module__icon--c_B6h";
export { _1 as "icon" }
